module.exports = __webpack_public_path__ + "img/aquila_guzzi.d0c142df.svg";